var React = require('react');

function ArrowSwirlUp16x32 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Size=16x32, Invert=off, Flip=off","clipPath":"url(#clip0_6934_26247)","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","key":0},[React.createElement("path",{"id":"Vector","d":"M14.394 4.24L9.636 1.82l-.746.275-1.98 4.882","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M9.19 2.035s6.46 14.031.242 17.877c-5.21 3.22-8.779-.834-7.636-3.84 1.216-3.21 5.47-3.538 7.569.11 2.472 4.35 1.459 15.227 1.459 15.227","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_6934_26247"},React.createElement("path",{"fill":"#fff","d":"M0 0h16v32H0z"})))]);
}

ArrowSwirlUp16x32.defaultProps = {"width":"16","height":"32","viewBox":"0 0 16 32","fill":"none"};

module.exports = ArrowSwirlUp16x32;

ArrowSwirlUp16x32.default = ArrowSwirlUp16x32;
